import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { PuzzleButton } from "./PuzzleButton";

export class PuzzlePage extends Phaser.Group {

    private puzzleButtonsKeys: string[];

    constructor(game: Phaser.Game, start: number, rows: number, totalProblems: number) {

        super(game, null, "puzzle-page");

        this.scale.y = GameVars.scaleY;

        const delta = 160;

        this.puzzleButtonsKeys = [];

        for (let i = 0; i < rows; i ++) {
            for (let j = 0; j < 4; j ++) {

                const index = start + i * 4 + j;

                if (index <= totalProblems) {
                    const px = GameConstants.GAME_WIDTH / 2 + delta * (j - 1.5);
                    const py = delta * i + 190;

                    const key = GameVars.puzzleMoves + "_" + (index - 1);
                    this.puzzleButtonsKeys.push(key);

                    const puzzleButton = new PuzzleButton(this.game, index, key);
                    puzzleButton.x = px;
                    puzzleButton.y = py;
                    this.add(puzzleButton);
                }
            }
        }
    }

    public lastProblem(): boolean {

        for (let i = 0; i < this.puzzleButtonsKeys.length; i++) {
            if (this.puzzleButtonsKeys[i] === GameVars.gameData.lastProblems[GameVars.puzzleMoves - 2]) {
                return true;
            }
        }

        return false;
    }
}
